import { axios, createFormData, handleError } from '../axios';

function rejectWithApiError(reject, payload) {
  const message = payload && payload.message ? payload.message : 'خطا در بارگذاری فایل قیمت';
  reject(new Error(message));
}

export const postFileUp = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('admin/post/file_up', createFormData(data))
      .then((response) => {
        try {
          const body = response.data;
          if (body && body.status === 'error') {
            rejectWithApiError(reject, body);
            return;
          }
          resolve(body);
        } catch (e) {
          reject(e);
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
        const message =
          e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : e.message || 'خطا در بارگذاری فایل قیمت';
        reject(new Error(message));
      });
  });
};
